import { z } from "zod";

const DataResponseSchema = z.object({
    id: z.number(),
    name: z.string(),
    display_name: z.nullable(z.string()),
    group: z.nullable(z.string()),
    guard_name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
});

export const PermissionResponseSchema = z.object({
    code: z.number(),
    data: DataResponseSchema,
    message: z.string(),
    success: z.boolean(),
});

export type PermissionResponse = z.infer<typeof PermissionResponseSchema>;